"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['Analyst', 'Architect', 'Assistant', 'Business Manager', 'C-Level / President / VP', 'Consultant', 'Developer / Programmer', 'Director', 'IT Manager', 'Network Administrator / Engineer', 'Owner / Partner', 'Student', 'System Administrator'];
exports.default = _default;
//# sourceMappingURL=title.js.map